import React from 'react';
import './Fluid.css';

const FluidImage = ({ src, alt }) => {
  return <img className={"fluidImage"} src={src} alt={alt} />;
};

export default FluidImage;
